import React from 'react';
import { TASK_DESCRIPTION_CYPRESS_TRIGGER } from '../TaskDescriptionField';

export const CypressWrappedComponent = ({
  show,
  showComponentForMode,
  children,
  className,
  role,
  tabIndex,
  onKeyDown,
  onClick
}: {
  show: boolean;
  showComponentForMode: boolean;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  role?: string;
  tabIndex?: number;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}) => {
  if (!showComponentForMode) return null;

  return (
    <div
      data-cypress-trigger={show ? TASK_DESCRIPTION_CYPRESS_TRIGGER : undefined}
      className={className}
      role={role}
      onClick={onClick}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  );
};
